import $ from 'jquery';
import BaseEvent from './base-event';

export default class SocialShareEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '2',
            category: 'share',
            action: 'click',
        });

        this.$socialShareCont = $('.social-media');

        this.init();
    }

    init() {
        this.onSocialShare();
    }

    onSocialShare() {
        this.$socialShareCont.find('button').on('click', (e) => {
            this.fireEvent({
                destination_url: window.location.toString(),
                label: this.toNormalizedString(e.currentTarget.title),
            });
        });
    }
}
